/* eslint-disable import/no-default-export */
import React from 'react';

import Badge from '../Badge';

const formatNumber = (num) =>
  num.toLocaleString(window.navigator.language, { maximumFractionDigits: 10 });

const NumberFieldBadge = ({ field, item }) => {
  if (!item || !item.value || !item.value.number) {
    return null;
  }
  const formatted = formatNumber(parseFloat(item.value.number));

  return (
    <Badge>
      <span>{`${field.name}: ${formatted}`}</span>
    </Badge>
  );
};

export default NumberFieldBadge;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/badges/NumberFieldBadge.js